import { theme } from '@frontend/theme';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  size?: 'small' | 'medium' | 'large' | 'xSmall' | 'xLarge';
  color: string;
}

const SIZE_MAP = {
  xSmall: 8,
  small: 12,
  medium: 16,
  large: 20,
  xLarge: 40,
};

export const ColorDot = ({ color, size = 'medium', ...rest }: Props) => {
  return (
    <span
      css={{
        display: 'inline-block',
        backgroundColor: color,
        borderRadius: theme.borderRadius.full,
        width: size ? SIZE_MAP[size] : SIZE_MAP.medium,
        height: size ? SIZE_MAP[size] : SIZE_MAP.medium,
        flexShrink: 0,
      }}
      {...rest}
    />
  );
};
